import { createTheme } from '@abyss/web/tools/theme';
import { V2Drawer } from '@abyss/web/ui/Drawer';
import { Markdown } from '@abyss/web/ui/Markdown';
import { ThemeProvider } from '@abyss/web/ui/ThemeProvider';

const h3Style = {
  fontFamily: 'inherit',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '1.4',
  letterSpacing: '0px',
  verticalAlign: 'middle',
  color: 'inherit',
  margin: '0 0 1em',
};

const DrawerHeading3 = ({ children }: { children: React.ReactNode }) => (
  <h3 style={h3Style}>{children}</h3>
);

const markdownOptions = {
  overrides: {
    h3: { component: DrawerHeading3 },
  },
};

export const InformationalDrawer = ({
  header,
  content,
  isDrawerOpen,
  setIsDrawerOpen,
}: {
  header: string;
  content: string;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}) => {
  const handleOnClose = () => {
    setIsDrawerOpen(false);
  };
  const theme = createTheme('uhc', { enterpriseFont: true });

  return (
    <ThemeProvider theme={theme}>
      <V2Drawer
        css={{
          'abyss-modal-base-header-container': {
            padding: '16px',
          },
        }}
        data-testid="informational-drawer"
        header={header}
        isOpen={isDrawerOpen}
        onClose={handleOnClose}
        position="right"
        size="$sm"
      >
        <Markdown options={markdownOptions}>{content}</Markdown>
      </V2Drawer>
    </ThemeProvider>
  );
};
